import axios from 'axios';

// Получаем имя конфигурационного файла из .env
const configFileName = 'config.json';

// Переменная для хранения apiUrl
let apiUrl = '';

// Функция загрузки конфигурации и создания экземпляра Axios
const loadConfig = async () => {
  try {
    const response = await fetch(`/${configFileName}`);
    const config = await response.json();
    
    // Устанавливаем базовый URL из конфигурации
    apiUrl = config.API_URL;

    // Создаем экземпляр Axios с базовым URL
    const instance = axios.create({
      baseURL: `${apiUrl}api/`,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return instance;
  } catch (error) {
    console.error('Ошибка при загрузке конфигурации:', error);
    return axios.create(); // Возвращаем экземпляр без URL в случае ошибки
  }
};

// Экспортируем как apiUrl, так и функцию для получения экземпляра Axios
export { apiUrl, loadConfig };
